import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiUtils } from '../../core_modules/utils/api-utils/api-utils';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  constructor(private http: HttpClient) {
  }

  upload(formData: FormData): Observable<any> {
    const req = ApiUtils.getRequest('file-upload/upload');
    return this.http.post<any>(req.url, formData);
  }

  getFileUrl(filename: string, bucketName: string): Observable<any> {
    const req = ApiUtils.getRequest('file-upload/get-file-url');

    return this.http.post<any>(req.url, {
      filename,
      bucketName
    });
  }

  delete(filename: string, documentType: string): Observable<any> {
    const req = ApiUtils.getRequest('file-upload/delete');

    return this.http.post<any>(req.url, {
      filename,
      documentType
    });
  }
}
